export default "__VITE_ASSET__C3Q_cJci__"